import angular from 'angular';
import 'angular-i18n/es-es';
import uiRouter from '@uirouter/angularjs';
import ngMessages from 'angular-messages';
import 'angular-sticky-plugin';
import purchaseListComponent from './purchaseListComponent';
import purchaseComponent from './purchaseComponent';
import purchaseSummaryComponent from './purchaseSummaryComponent';
import purchaseConfirmComponent from './purchaseConfirmComponent';

let componentName = 'ofertaNavidad';

const navidad = {
  name: 'navidad',
  abstract: true,
  template: '<ui-view></ui-view>'
};

const purchase = {
  name: 'purchase',
  abstract: true,
  parent: navidad,
  component: 'purchase'
};

const list = {
  name: 'list',
  parent: purchase,
  component: 'purchaseList'
};

const confirm = {
  name: 'purchaseConfirm',
  component: 'purchaseConfirm',
  parent: purchase,
};

const success = {
  name: 'success',
  parent: navidad,
  templateUrl: '/template/render/?tpl=/oferta-navidad/pedido-recibido.php'
};

const states = [navidad, purchase, list, confirm, success];

const errorMessages = {
  name: 'errorMessages',

  templateUrl: '/template/render/?tpl=/oferta-navidad/error.php',
  transclude: true,
  bindings: {
    field: '<'
  },
  controller: class {
    constructor() {
      this.messagesEuskera = [
        {key: 'required', text: 'Zerbait sartu behar duzu'},
        {key: 'number', text: 'Zenbaki bat sartu behar duzu'},
        {key: 'minlength', text: 'Zenbaki handiagoa sartu behar duzu'},
        {key: 'maxlength', text: 'Zenbaki txikiagoa sartu behar duzu'},
        {key: 'email', text: 'Email formatoarekin sartu behar duzu'}
      ];

      this.messages = [
        {key: 'required', text: 'Debes introducir un valor'},
        {key: 'number', text: 'Debes introducir un numero'},
        {key: 'minlength', text: 'Debes introducir un numero mayor'},
        {key: 'maxlength', text: 'Debes introducir un numero menor'},
        {key: 'email', text: 'Debe tener formato de correo electrónico'}
      ];
    }
  }
};

const initialize = (componentName, states, ...components) => {
  const rootComponent = {
    name: componentName,
    template: '<ui-view></ui-view>'
  };

  const module = angular.module(componentName, [uiRouter, ngMessages, 'hl.sticky']);
  components.concat([rootComponent]).forEach(component => module.component(component.name, component));

  module.config(['$stateProvider', '$urlServiceProvider',  ($stateProvider, $urlServiceProvider) => {
    states.forEach(s => $stateProvider.state(s));
    $urlServiceProvider.rules.otherwise({state: list.name});
  }]);
};

const toCamel = text => text.replace(/(-[a-z])/g, txt => txt.toUpperCase().replace('-', ''));
const toSnake = text => text.replace(/([A-Z])/g, txt => `-${txt.toLowerCase()}`);

const lanzador = () => {
  let root = document.querySelector('[data-component]');
  const componentName = root.getAttribute('data-component');
  root.innerHTML = `<${componentName}></${componentName}>`;
  angular.bootstrap(root, [toCamel(componentName)]);
};

initialize(
    componentName,
    states,
    purchaseComponent,
    purchaseSummaryComponent,
    purchaseListComponent,
    purchaseConfirmComponent,
    errorMessages
);

document.addEventListener('DOMContentLoaded', lanzador);


// WEBPACK FOOTER //
// ./oferta-navidad/ofertaNavidad.js